var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('drill-report-base',_vm._b({attrs:{"record-id":_vm.$route.query.id}},'drill-report-base',_vm.$route.query,false))
}
var staticRenderFns = []

export { render, staticRenderFns }